module.exports = __webpack_public_path__ + "fonts/MyriadPro-Light.c37920f9.otf";